import { Action } from '@ngrx/store';
import {
  ClaimLine,
  ClaimLineForm,
  ClaimRequest
} from '@ecosure-suite/shared/util-entities';
import { Pagination } from '@ecosure-suite/shared/utils-helpers';

export enum ClaimLinesActionTypes {
  LOAD_CLAIM_LINE = '[ClaimLines] Load Claim Lines',
  LOAD_CLAIM_LINE_SUCCESS = '[ClaimLines] Load Claim Lines Success',
  LOAD_CLAIM_LINE_FAIL = '[ClaimLines] Load Claim Lines Fail',
  CREATE_CLAIM_LINE = '[ClaimLines] Create',
  CREATE_CLAIM_LINE_SUCCESS = '[ClaimLines] Create Success',
  CREATE_CLAIM_LINE_FAIL = '[ClaimLines] Create Fail',
  EDIT_CLAIM_LINE = '[ClaimLines] Edit',
  EDIT_CLAIM_LINE_SUCCESS = '[ClaimLines] Edit Success',
  EDIT_CLAIM_LINE_FAIL = '[ClaimLines] Edit Fail',
  DELETE_CLAIM_LINE = '[ClaimLines] Delete',
  DELETE_CLAIM_LINE_SUCCESS = '[ClaimLines] Delete Success',
  DELETE_CLAIM_LINE_FAIL = '[ClaimLines] Delete Fail',
  SUBMIT_CLAIM_LINE = '[ClaimLines] Submit',
  SUBMIT_CLAIM_LINE_SUCCESS = '[ClaimLines] Submit Success',
  SUBMIT_CLAIM_LINE_FAIL = '[ClaimLines] Submit Fail',
  LIST_CLAIM_LINE_BY_STATUS = '[ClaimLines] List By Status',
  LIST_CLAIM_LINE_BY_STATUS_SUCCESS = '[ClaimLines] List By Status Success',
  LIST_CLAIM_LINE_BY_STATUS_FAIL = '[ClaimLines] List By Status Fail',
  LIST_CLAIM_LINE_BY_ASSIGNEE = '[ClaimLines] List By Assignee',
  LIST_CLAIM_LINE_BY_ASSIGNEE_SUCCESS = '[ClaimLines] List By Assignee Success',
  LIST_CLAIM_LINE_BY_ASSIGNEE_FAIL = '[ClaimLines] List By Assignee Fail',
  LIST_CLAIM_LINE_BY_CURRENT_USER = '[ClaimLines] List By Current User',
  LIST_CLAIM_LINE_BY_CURRENT_USER_SUCCESS = '[ClaimLines] List By Current User Success',
  LIST_CLAIM_LINE_BY_CURRENT_USER_FAIL = '[ClaimLines] List By Current User Fail',
  ASSIGN_CLAIM_LINE = '[ClaimLines] Assign',
  ASSIGN_CLAIM_LINE_SUCCESS = '[ClaimLines] Assign Success',
  ASSIGN_CLAIM_LINE_FAIL = '[ClaimLines] Assign Fail',
  VERIFY_CLAIM_LINE = '[ClaimLines] Verify',
  VERIFY_CLAIM_LINE_SUCCESS = '[ClaimLines] Verify Success',
  VERIFY_CLAIM_LINE_FAIL = '[ClaimLines] Verify Fail',
  APPROVE_CLAIM_LINE = '[ClaimLines] Approve',
  APPROVE_CLAIM_LINE_SUCCESS = '[ClaimLines] Approve Success',
  APPROVE_CLAIM_LINE_FAIL = '[ClaimLines] Approve Fail',
  RETURN_CLAIM_LINE = '[ClaimLines] Return',
  RETURN_CLAIM_LINE_SUCCESS = '[ClaimLines] Return Success',
  RETURN_CLAIM_LINE_FAIL = '[ClaimLines] Return Fail',
  REJECT_CLAIM_LINE = '[ClaimLines] Reject',
  REJECT_CLAIM_LINE_SUCCESS = '[ClaimLines] Reject Success',
  REJECT_CLAIM_LINE_FAIL = '[ClaimLines] Reject Fail',
  SELECT_CLAIM_LINE = '[ClaimLines] Select'
}

export class LoadClaimLines implements Action {
  readonly type = ClaimLinesActionTypes.LOAD_CLAIM_LINE;
  constructor(public payload: { claimId: number; claimRequestId: number }) {}
}

export class LoadClaimLinesSuccess implements Action {
  readonly type = ClaimLinesActionTypes.LOAD_CLAIM_LINE_SUCCESS;
  constructor(public payload: ClaimLine[]) {}
}

export class LoadClaimLinesFail implements Action {
  readonly type = ClaimLinesActionTypes.LOAD_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class CreateClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.CREATE_CLAIM_LINE;
  constructor(public payload: ClaimLineForm) {}
}

export class CreateClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.CREATE_CLAIM_LINE_SUCCESS;
  constructor(public payload: ClaimLine) {}
}

export class CreateClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.CREATE_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class EditClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.EDIT_CLAIM_LINE;
  constructor(public payload: ClaimLineForm) {}
}

export class EditClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.EDIT_CLAIM_LINE_SUCCESS;
  constructor(public payload: ClaimLine) {}
}

export class EditClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.EDIT_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class DeleteClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.DELETE_CLAIM_LINE;
  constructor(public payload: Partial<ClaimLine>) {}
}

export class DeleteClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.DELETE_CLAIM_LINE_SUCCESS;
  constructor(public payload: Partial<ClaimLine>) {}
}

export class DeleteClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.DELETE_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class ListClaimLinesByStatus implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_STATUS;
  constructor(
    public payload: {
      status: string;
      currentPage: number;
      itemsPerPage: number;
    }
  ) {}
}

export class ListClaimLinesByStatusSuccess implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_STATUS_SUCCESS;
  constructor(
    public payload: {
      claimLines: (ClaimLine & { claimRequest: ClaimRequest })[];
      page: Pagination;
    }
  ) {}
}

export class ListClaimLinesByStatusFail implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_STATUS_FAIL;
  constructor(public payload: Error) {}
}

export class ListClaimLinesByAssignee implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_ASSIGNEE;
  constructor(
    public payload: {
      username: string;
      currentPage: number;
      itemsPerPage: number;
    }
  ) {}
}
export class ListClaimLinesByAssigneeSuccess implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_ASSIGNEE_SUCCESS;
  constructor(
    public payload: {
      claimLines: (ClaimLine & { claimRequest: ClaimRequest })[];
      page: Pagination;
    }
  ) {}
}

export class ListClaimLinesByAssigneeFail implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_ASSIGNEE_FAIL;
  constructor(public payload: Error) {}
}

export class ListClaimLinesByCurrentUser implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_CURRENT_USER;
  constructor(
    public payload: {
      currentPage: number;
      itemsPerPage: number;
    }
  ) {}
}

export class ListClaimLinesByCurrentUserSuccess implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_CURRENT_USER_SUCCESS;
  constructor(public payload: { claimLines: ClaimLine[]; page: Pagination }) {}
}

export class ListClaimLinesByCurrentUserFail implements Action {
  readonly type = ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_CURRENT_USER_FAIL;
  constructor(public payload: Error) {}
}

export class AssignClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.ASSIGN_CLAIM_LINE;
  constructor(
    public payload: { claimId: number; claimLineId: number; username: string }
  ) {}
}

export class AssignClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.ASSIGN_CLAIM_LINE_SUCCESS;
  constructor(public payload: Partial<ClaimLine>) {}
}

export class AssignClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.ASSIGN_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class SubmitClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.SUBMIT_CLAIM_LINE;
  constructor(public payload: number) {}
}
export class SubmitClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.SUBMIT_CLAIM_LINE_SUCCESS;
  constructor(public payload: any) {}
}

export class SubmitClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.SUBMIT_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class VerifyClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.VERIFY_CLAIM_LINE;
  constructor(public payload: { claimLineId: number; comment: string }) {}
}

export class VerifyClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.VERIFY_CLAIM_LINE_SUCCESS;
  constructor(public payload: Partial<ClaimLine>) {}
}

export class VerifyClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.VERIFY_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class ApproveClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.APPROVE_CLAIM_LINE;
  constructor(public payload: { claimLineId: number; comment: string }) {}
}

export class ApproveClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.APPROVE_CLAIM_LINE_SUCCESS;
  constructor(public payload: Partial<ClaimLine>) {}
}

export class ApproveClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.APPROVE_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class ReturnClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.RETURN_CLAIM_LINE;
  constructor(public payload: { claimLineId: number; comment: string }) {}
}

export class ReturnClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.RETURN_CLAIM_LINE_SUCCESS;
  constructor(public payload: Partial<ClaimLine>) {}
}

export class ReturnClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.RETURN_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class RejectClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.REJECT_CLAIM_LINE;
  constructor(public payload: { claimLineId: number; comment: string }) {}
}

export class RejectClaimLineSuccess implements Action {
  readonly type = ClaimLinesActionTypes.REJECT_CLAIM_LINE_SUCCESS;
  constructor(public payload: Partial<ClaimLine>) {}
}

export class RejectClaimLineFail implements Action {
  readonly type = ClaimLinesActionTypes.REJECT_CLAIM_LINE_FAIL;
  constructor(public payload: Error) {}
}

export class SelectClaimLine implements Action {
  readonly type = ClaimLinesActionTypes.SELECT_CLAIM_LINE;
  constructor(public payload: number) {}
}

export type ClaimLinesAction =
  | LoadClaimLines
  | LoadClaimLinesSuccess
  | LoadClaimLinesFail
  | CreateClaimLine
  | CreateClaimLineSuccess
  | CreateClaimLineFail
  | EditClaimLine
  | EditClaimLineSuccess
  | EditClaimLineFail
  | DeleteClaimLine
  | DeleteClaimLineSuccess
  | DeleteClaimLineFail
  | SubmitClaimLine
  | SubmitClaimLineSuccess
  | SubmitClaimLineFail
  | ListClaimLinesByStatus
  | ListClaimLinesByStatusSuccess
  | ListClaimLinesByStatusFail
  | ListClaimLinesByAssignee
  | ListClaimLinesByAssigneeSuccess
  | ListClaimLinesByAssigneeFail
  | ListClaimLinesByCurrentUser
  | ListClaimLinesByCurrentUserSuccess
  | ListClaimLinesByCurrentUserFail
  | AssignClaimLine
  | AssignClaimLineSuccess
  | AssignClaimLineFail
  | VerifyClaimLine
  | VerifyClaimLineSuccess
  | VerifyClaimLineFail
  | ApproveClaimLine
  | ApproveClaimLineSuccess
  | ApproveClaimLineFail
  | ReturnClaimLine
  | ReturnClaimLineSuccess
  | ReturnClaimLineFail
  | RejectClaimLine
  | RejectClaimLineSuccess
  | RejectClaimLineFail
  | SelectClaimLine;

export const fromClaimLinesActions = {
  LoadClaimLines,
  LoadClaimLinesSuccess,
  LoadClaimLinesFail,
  CreateClaimLine,
  CreateClaimLineSuccess,
  CreateClaimLineFail,
  EditClaimLine,
  EditClaimLineSuccess,
  EditClaimLineFail,
  DeleteClaimLine,
  DeleteClaimLineSuccess,
  DeleteClaimLineFail,
  SubmitClaimLine,
  SubmitClaimLineSuccess,
  SubmitClaimLineFail,
  ListClaimLinesByStatus,
  ListClaimLinesByStatusSuccess,
  ListClaimLinesByStatusFail,
  ListClaimLinesByAssignee,
  ListClaimLinesByAssigneeSuccess,
  ListClaimLinesByAssigneeFail,
  ListClaimLinesByCurrentUser,
  ListClaimLinesByCurrentUserSuccess,
  ListClaimLinesByCurrentUserFail,
  AssignClaimLine,
  AssignClaimLineSuccess,
  AssignClaimLineFail,
  VerifyClaimLine,
  VerifyClaimLineSuccess,
  VerifyClaimLineFail,
  ApproveClaimLine,
  ApproveClaimLineSuccess,
  ApproveClaimLineFail,
  ReturnClaimLine,
  ReturnClaimLineSuccess,
  ReturnClaimLineFail,
  RejectClaimLine,
  RejectClaimLineSuccess,
  RejectClaimLineFail,
  SelectClaimLine
};
